import { render, staticRenderFns } from "./Edit.vue?vue&type=template&id=6118fa1e&"
import script from "./Edit.vue?vue&type=script&lang=js&"
export * from "./Edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6118fa1e')) {
      api.createRecord('6118fa1e', component.options)
    } else {
      api.reload('6118fa1e', component.options)
    }
    module.hot.accept("./Edit.vue?vue&type=template&id=6118fa1e&", function () {
      api.rerender('6118fa1e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/ccd/tenancy/representative/Edit.vue"
export default component.exports